import { provideApollo } from 'apollo-angular';
import { inject } from '@angular/core';
import { SetContextLink } from '@apollo/client/link/context';
import { HttpHeaders } from '@angular/common/http';
import { INFRASTRUCTURE_CONFIG } from '../infrastructure/infrastructure-config.token';
import { apolloBaseHelper } from './apollo-base-helper';
import { KeycloakService } from './keycloak-service';

export function provideApolloConfig() {
  return provideApollo(() => {
    const config = inject(INFRASTRUCTURE_CONFIG);
    const keycloakService = inject(KeycloakService);

    const { graphql_server_uri, auth_header_name: authHeaderName } =
      config.environment;

    const auth = new SetContextLink(({ headers }) => {
      if (!keycloakService.token) return {};

      // apollo-angular v14 widened the context to
      // `HttpHeaders | Record<string, string>`, so narrow before appending.
      const currentHeaders =
        headers instanceof HttpHeaders ? headers : new HttpHeaders(headers);

      return {
        headers: currentHeaders.append(authHeaderName, keycloakService.token)
      };
    });

    return apolloBaseHelper(graphql_server_uri, auth);
  });
}
